//-------------------------------------------------------------------------
// Temporary custom Tabs pending proper re-factoring of application theme
//-------------------------------------------------------------------------

// TODO: Move these styling changes to a global theme override (affecting
//       MuiTabs) so that the standard Tabs class will be properly
//       themed with Nuvoola's theme.
// TODO: Once the above is done:
//       - Replace all instances of NuvTabs with Tabs.
//       - Delete this file.

import { withStyles } from "@material-ui/styles";
import TabList from "@material-ui/lab/TabList";
import colors from "../../assets/style/colors";

const NuvTabList = withStyles((theme) => ({
    root: {
        border: '1px solid',
        borderColor: colors.black20,
    },
    indicator: {
        backgroundColor: colors.primary,
    }
}))(TabList);

export default NuvTabList;